/**
 * Dev-only logger. Strips noisy `console.error` calls in production builds
 * (CRA exposes `process.env.NODE_ENV === 'production'` for prod bundles)
 * while preserving stack traces during local development.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => {
    if (isDev) console.error(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  log: (...args) => {
    if (isDev) console.log(...args);
  },
};

export default logger;
